export function getInitialRequestedMode({ routeMode, isAdmin, isAdminMode }) {
  return routeMode === "view" && isAdmin && isAdminMode ? "view" : "edit";
}

export function canUseEditorActions({ mode, accessHealthy }) {
  return mode === "edit" && accessHealthy;
}

export function getAccessNoticeDismissLocation({ notice, search }) {
  if (!notice?.exitOnDismiss) return null;
  return { pathname: "/", search };
}

export function getSaveAlertMessage({ autosave, outcome }) {
  if (autosave) return null;
  switch (outcome) {
    case "success":
      return "Annotation sheet saved successfully!";
    case "failure":
      return "Failed to save annotation sheet. Please try again.";
    case "error":
      return "An error occurred while saving the annotation sheet.";
    default:
      return null;
  }
}

export function requestModeChange(targetMode, access) {
  switch (targetMode) {
    case "view":
      return access.switchToViewing();
    case "edit":
      return access.switchToEditing();
    case "track-edit":
      return access.switchToTrackEditing();
    default:
      return Promise.resolve(false);
  }
}
